import React from 'react';
import OpportunitySkeleton from '@components/OpportunityListing/components/LoadersAndEmptyStates/OpportunitySkeleton';
import TopBar from '@components/OpportunityListing/components/TopBar';

const HeaderSkeleton = ({ isActiveOpportunities = true }) => {
    return (
        <div className="w-full">
            <div className="max-w-[1184px] mx-auto w-full px-4 md:px-12">
                <div className="flex flex-col">
                    <TopBar
                        title={
                            isActiveOpportunities
                                ? 'Active Opportunities'
                                : 'Recently Closed Opportunities'
                        }
                        description={
                            isActiveOpportunities
                                ? 'Invest in curated, secured, high-yield opportunities'
                                : 'Take a glance at some of our past opportunities'
                        }
                    />
                </div>
                {/* Here  */}
                <div className="z-10 flex flex-col bg-transparent">
                    <div className="flex flex-row justify-between">
                        <div className="flex w-full md:items-center md:w-fit">
                            {[1, 2, 3].map((index) => (
                                <div
                                    key={index}
                                    className="inline-flex px-2 py-3 relative text-basicWhite w-full flex-center p6-regular md:h6-regular cursor-pointer flex-1 rounded-br-lg overflow-hidden md:flex-1 md:min-w-[180px] flex-col md:flex-row gap-2 bg-gray-200/20 animate-pulse"
                                >
                                    <div className="w-6 h-6 rounded-full bg-gray-200/40" />
                                    <div className="w-24 h-6 rounded bg-gray-200/40" />
                                </div>
                            ))}
                        </div>
                        <div className="hidden md:inline-flex">
                            <div className="w-40 h-8 rounded bg-gray-200/20 animate-pulse" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const BannerSkeleton = () => {
    return (
        <div className="w-full max-w-[1184px] mx-auto px-4 md:px-12 pt-6">
            <div className="relative inline-flex w-full flex-col items-center justify-start gap-4 px-6 py-4 overflow-hidden border md:max-w-[712px] sm:max-w-[344px] md:items-center rounded-lg mx-auto xl:max-w-[1096px] md:gap-14 xl:gap-14 md:justify-between md:pl-24 md:flex-row bg-secondary-50 border-secondary-300">
                <div className="flex flex-col md:flex-row items-center self-stretch justify-start gap-4 md:gap-6 z-[1] md:flex-1 md:justify-between">
                    <div className="self-stretch text-center md:text-left">
                        <div className="w-48 h-6 mb-2 bg-gray-200 rounded animate-pulse" />
                        <div className="w-64 h-6 bg-gray-200 rounded animate-pulse" />
                    </div>
                    <div className="relative flex flex-col items-start self-stretch justify-start h-12 gap-4 xl:flex-row xl:items-center xl:gap-6">
                        <div className="inline-flex xl:p-3 xl:rounded-xl xl:gap-4 items-center justify-start gap-2 z-[1] xl:bg-semantic-success-light">
                            <div className="w-4 h-4 bg-gray-200 rounded-full xl:w-6 xl:h-6 animate-pulse" />
                            <div className="w-32 h-6 bg-gray-200 rounded animate-pulse" />
                        </div>
                        <div className="inline-flex xl:p-3 xl:rounded-xl xl:gap-4 items-center justify-start gap-2 z-[1] xl:bg-gray-200">
                            <div className="w-4 h-4 bg-gray-200 rounded-full xl:w-6 xl:h-6 animate-pulse" />
                            <div className="w-40 h-6 bg-gray-200 rounded animate-pulse" />
                        </div>
                        <div className="absolute w-px h-full origin-top-left border-l-2 border-gray-400 border-dotted left-[7px] xl:hidden"></div>
                        <div className="absolute hidden w-full h-px origin-top-left border-b-2 border-gray-400 border-dotted xl:-translate-y-1/2 xl:block xl:top-1/2"></div>
                    </div>
                </div>
                <div className="self-start md:self-center z-[1] pt-4">
                    <div className="w-32 h-10 bg-gray-200 rounded-full animate-pulse" />
                </div>
            </div>
        </div>
    );
};

const FiltersSkeleton = () => {
    return (
        <div className="flex-wrap hidden gap-4 p-4 bg-white rounded-lg shadow-sm md:flex animate-pulse">
            <div className="w-32 h-10 bg-gray-200 rounded" />
            <div className="w-32 h-10 bg-gray-200 rounded" />
            <div className="w-32 h-10 bg-gray-200 rounded" />
        </div>
    );
};

const RegulationTabsSkeleton = () => {
    return (
        <div className="inline-flex items-start justify-start gap-3 mx-auto overflow-hidden md:gap-0 md:mx-0">
            {[1, 2].map((index) => (
                <div
                    key={index}
                    className="md:border-2 border border-gray-200 md:border-transparent list-none cursor-pointer flex items-center py-[10px] pr-[10px] pl-[14px] md:bg-transparent bg-basicWhite rounded-md md:rounded-none animate-pulse"
                >
                    <div className="w-24 h-6 bg-gray-200 rounded" />
                    <div className="ml-[10px] w-5 h-5 rounded-full bg-gray-200" />
                </div>
            ))}
        </div>
    );
};

const OpportunityCardsGridSkeleton = ({ count = 6 }) => {
    return (
        <div className="grid grid-cols-1 gap-8 md:gap-10 md:grid-cols-2 xl:grid-cols-3">
            {Array.from({ length: count }).map((_, index) => (
                <OpportunitySkeleton />
            ))}
        </div>
    );
};

const OpportunityListingPageSkeleton = ({ isActiveOpportunities = true }) => {
    return (
        <div className="relative flex flex-col items-center min-h-screen pt-16 bg-opportunities-gradient">
            <BannerSkeleton />
            <HeaderSkeleton isActiveOpportunities={isActiveOpportunities} />
            <div className="w-full min-h-screen px-4 py-6 md:px-0 md:py-10 md:pt-6 bg-basicWhite">
                <div className="max-w-[1184px] mx-auto w-full px-4 md:px-12">
                    {/* here */}
                    <div className="flex flex-col gap-6">
                        {/* Filters Skeleton */}
                        <FiltersSkeleton />

                        {/* Regulation Tabs Skeleton */}
                        <RegulationTabsSkeleton />
                        {/* Opportunity Cards Grid Skeleton */}
                        <OpportunityCardsGridSkeleton count={9} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpportunityListingPageSkeleton;
